export const genericSort = (s1, s2, options) => {
    const sortFactor = options?.reverse ? -1 : 1;
    if (s1 < s2)
        return -1 * sortFactor;
    if (s1 > s2)
        return 1 * sortFactor;
    return 0;
};
export const sortFnByKey = (key, options) => {
    return (s1, s2) => genericSort(s1[key], s2[key], options);
};
export const sortFnByFn = (fn, options) => {
    return (s1, s2) => genericSort(fn(s1), fn(s2), options);
};
export const sortByKey = (objects, key, options) => {
    return [...objects].sort(sortFnByKey(key, options));
};
export const sortByFn = (objects, fn, options) => {
    return [...objects].sort(sortFnByFn(fn, options));
};
export const sortByKeys = (objects, keys, options) => {
    return [...objects].sort((a, b) => {
        return keys.reduce((sortResult, key) => sortResult || sortFnByKey(key, options)(a, b), 0);
    });
};
//# sourceMappingURL=utils-sort.js.map